import ChatChannelsList from './ChatChannelsList';

export default ChatChannelsList;
